
<template>
  <!--住户认证记录-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="householder_apply_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :rowSelection="false"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-button v-for="(item, index) of rowOptList" :key="index"
                  @click="item.handle(row)" type="link" :disabled="row.status !== 0">{{item.text}}</a-button>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'householdAuthRecord',
  data () {
    return {
      searchList: [
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select' },
        { props: ['keywords'], placeholder: '手机号、房间号', options: [], inputType: 'input' },
        { props: ['household_type'], placeholder: '认证类型', options: [], inputType: 'select' },
        { props: ['auth_resource'], placeholder: '认证方式', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '审核状态', options: [], inputType: 'select' },
        { props: ['areas'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['property_id'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['提交时间', '提交时间'], options: [], inputType: 'datePick' },
        { props: ['check_date'], placeholder: ['审核时间', '审核时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        {text: '审核', handle: (row) => this.$children[0].toEdit(row, ['status']), key: 'audit'}
      ],
      columns: [
        { title: 'ID', dataIndex: 'householder_apply_id', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '认证类型', dataIndex: 'household_type_desc', align: 'left', width: '' },
        { title: '申请房间', dataIndex: 'room_address', align: 'left', width: '' },
        { title: '提交时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '认证方式', dataIndex: 'auth_resource_desc', align: 'left', width: '' },
        { title: '审核状态', dataIndex: 'verify_status_desc', align: 'left', width: '' },
        { title: '审核人', dataIndex: 'check_user_name', align: 'left', width: '' },
        { title: '审核时间', dataIndex: 'check_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action_o'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: '',
        keywords: '',
        household_type: '',
        auth_resource: '',
        status: '',
        areas: '',
        property_id: '',
        create_date: '',
        check_date: ''
      },
      listApi: {
        url: '/householder',
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'householdAuthDetail',
        title: ''
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(5);
      this.propertySelect(6);
      this.communitySelect(0, 'searchList', 1);
      let paramArr = [
        { index: 2, key: 'household_type' },
        { index: 3, key: 'auth_resource' },
        { index: 4, key: 'check_status' }
      ];
      this.memberManageSelect(paramArr);
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/member/householdAuthRecord/householdAuthRecord.vue